module.exports = __webpack_public_path__ + "static/media/DSC_0272.0d4e9cc2.jpg";